module.exports = {
    zh: {
        newNotice: { //新建通知
           title: "新建通知",
           theme: "主题",
           content: "内容",
           enclosure: "附件",
           sendingTime: "发送时间",
           immediately: "立即",
           timing: "定时",
           sendee: "接收人",
           confirm: "确定",
           send: "发送",
           cancel: "取消",
           upload: "上传",
           parents: "家长",
           workers: "职工",
           customparents: "自定义家长",
           customworkers: "自定义职工",
           checkAll: "全选",
           custom: "自定义",
           phone: "手机号码",
           product:'产品',
           suggest:'意见反馈',
           productName:'产品类型',
           createTime:'反馈时间',
           createUserName:'反馈人',
           chineseName:"中文名称",
           englishName: "英文名称",
           babyName:"宝宝姓名",
           gardenName: "所属园区",
           number: "序号",
           isAccount: "是否分配账户",
           staffed:"职工编号",
           class:"负责班级",
           role:"角色",
           employmentType: "雇佣类型"
        },
        notification:{ //通知列表
            sendTime: "发送时间",
            newTime: "新建时间",
            state: "状态",
            newBuilt:"新建",
            passThrough: "审核通过",
            notPassThrough:"审核不通过",
            readState:"读取状态",
            title:"通知详情",
        },
        studentsLeave:{  //学生请假
            students: "学生姓名",
            leaveType: "请假类型",
            startTime: "开始时间",
            time:"起止日期",
            endTime:"结束时间",
            park: "园区",
            class: "班级",
            state: "状态",
            new: "新建",
            approval: "批准",
            revoke:"撤销",
            newLeave: "新建请假",
            reasonLeave: "请假原因",
            submission: "提交",
            datailsLeave: "请假详情",
            proposeTime: "提出时间",
            confirmationPerson: "确认人",
            confirmationTime: "确认时间",
            replayContent: "园所回复",
            leaveApproval: "请假批准",
            revokeOfRevocation: "撤销原因",
            daysofleave:"请假天数",
            handle: "处理",
            submitPeople: "提交人",
            replyContent:"回复内容",
            replyTime:"回复时间",
            revokePeople:"撤销人",
            revokeTime:"撤销时间",
        },
        chiefMailbox:{  //园长邮箱
            parent: "家长",
            children: "孩子",
            receivingTime: "接收时间",
            recoveryTime: "回复时间",
            park: "园区",
            class: "班级",
            state: "状态",
            mailboxContent: "信箱内容",
            mailContentTime:"信箱内容",
            handlingStatus: "处理状态",
            replyContent:"回复内容",
            replyMailbox: "回复信箱",
            replyContentTime:"回复内容",
            reply: "回复",
            lookMailbox: "查看信箱",
            close:"关闭"
        },
        search:"搜索",
        reset:"重置",
        operation:"操作",
        check:"查看",
        number:"序号",
        edit:"编辑",
        cancel:"取消",
        save:"保存"
    },
    en: {
        newNotice: { //新建通知
            title: "newNotice",
            theme: "theme",
            content: "content",
            enclosure: "enclosure",
            sendTime: "sendingTime",
            immediately: "immediately",
            timing: "timing",
            sendee: "sendee",
            send: "send",
            confirm: "confirm",
            cancel: "cancel",
            upload: "upload",
            parents: "family",
            workers: "workers",
            customparents: "custom parents",
            customworkers: "custom workers",
            checkAll: "checkAll",
            custom: "custom",
            phone: "photo",
            product:'product',
            suggest:'suggest',
            productName:'productName',
            createTime:'Feedback time',
            createUserName:'Feedback person',
            chineseName:"chineseName",
            englishName: "englishName",
            babyName:"babyName",
            gardenName: "gardenName",
            number: "number",
            isAccount: "isAccount",
            staffed: "staffed",
            class:"class",
            role:"role",
            employmentType: "employmentType"

        },
        notification:{  //通知列表
            sendingTime: "sending time",
            newTime: "new time",
            state: "state",
            newBuilt:"new-built",
            passThrough: "pass through",
            notPassThrough:"not pass through",
            title:"Details of notification",
            readState:"read status",
        },
        studentsLeave:{  //学生请假
            students: "students",
            leaveType: "leave of type",
            startTime: "start time",
            endTime:"end time",
            time:"start stop time",
            park: "park",
            class: "class",
            state: "state",
            new: "new",
            approval: "approval",
            revoke:"revoke",
            newLeave: "New leave for leave",
            reasonLeave: "Reasons for leave",
            submission: "submission",
            datailsLeave: "datails of Leave",
            proposeTime: "propose time",
            confirmationPerson: "confirmation person",
            confirmationTime: "confirmation time",
            replayContent: "replay content",
            leaveApproval: "leave Approval",
            revokeOfRevocation: "revoke of revocation",
            daysofleave:"days of leave",
            handle: "handle",
            submitPeople: "Submit one",
            replyContent:"Reply content",
            replyTime:"Reply time",
            revokePeople:"Revoke people",
            revokeTime:"Revoke time",
        },
        chiefMailbox:{  //邮箱
            parent: "parent",
            children: "children",
            receivingTime: "receiving time",
            recoveryTime: "recovery time",
            park: "park",
            class: "class",
            state: "state",
            mailboxContent: "mailbox content",
            mailContentTime: "mailbox content",
            handlingStatus: "handling status",
            replyContent:"reply content",
            replyMailbox: "reply mailbox",
            replyContentTime:"reply content",
            reply: "reply",
            lookMailbox: "look mailbox",
            close:"close"
        },
        search:"search",
        reset:"reset",
        operation:"operation",
        check:"check",
        number:"id",
        edit:"edit",
        cancel:"cancel",
        save:"save"
    }
}



// WEBPACK FOOTER //
// ./src/components/i18n/lang/notificationManagement.js